import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';

const ParallaxImage = ({ src, alt, className = '', speed = 0.1 }) => {
  const ref = useRef(null);
  const shouldReduceMotion = useReducedMotion();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });

  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);

  if (shouldReduceMotion) {
    return (
      <div ref={ref} className={`overflow-hidden relative ${className}`}>
        <img src={src} alt={alt} className="w-full h-full object-cover" />
      </div>
    );
  }

  return (
    <div ref={ref} className={`overflow-hidden relative ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        className="w-full h-full object-cover scale-110"
        style={{ y: useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`]) }}
      />
    </div>
  );
};

export default ParallaxImage;
